module.exports = __webpack_public_path__ + "static/media/pradip-profile.571d5f4c.jpg";